import React, { useContext } from 'react';
import { H5, H6, LI, UL } from '../../../AbstractElements';
import { Archive } from 'react-feather';
import { Col, Row } from 'reactstrap';
import { Arrowsvg, Filesvg } from '../Svg';
import { knowledgearticl } from '../../../Constant';
import JobSearchContext from '../../../Context/JobSearch';
import { Link } from 'react-router-dom';


const CategoryData = () => {
  const { searchData } = useContext(JobSearchContext);

  return (
    <Col sm='12'>
      <div className='header-faq'>
        <H5 className='mb-0'>{knowledgearticl}</H5>
      </div>
      <Row className='browse'>
        {searchData &&
          searchData.map((data) => {
            return (
              <Col xl='4' md='6' key={data.id}>
                <div className='browse-articles browse-bottom'>
                  <H6>
                    <span>
                      <Archive />
                    </span>
                    {data.inspantitle}
                    {data.title}
                  </H6>
                  <UL className='simple-list'>
                    <LI>
                      <Link to={`${process.env.PUBLIC_URL}/knowledgebase/knowledge-detail`}>
                        <H5>
                          <Filesvg /> {data.text1}
                        </H5>
                      </Link>
                    </LI>
                    <LI>
                      <Link to={`${process.env.PUBLIC_URL}/knowledgebase/knowledge-detail`}>
                        <H5>
                          <Filesvg /> {data.text2}
                        </H5>
                      </Link>
                    </LI>
                    <LI>
                      <Link to={`${process.env.PUBLIC_URL}/knowledgebase/knowledge-detail`}>
                        <H5>
                          <Filesvg /> {data.text3}
                        </H5>
                      </Link>
                    </LI>
                    <LI>
                      <Link to={`${process.env.PUBLIC_URL}/knowledgebase/knowledge-detail`}>
                        <H5>
                          <Filesvg /> {data.text4}
                        </H5>
                      </Link>
                    </LI>
                    <LI>
                      <Link to={`${process.env.PUBLIC_URL}/knowledgebase/knowledge-detail`} className='f-w-600 font-primary'>
                        <Arrowsvg />
                        <span>{data.text5}</span>
                      </Link>
                    </LI>
                  </UL>
                </div>
              </Col>
            );
          })}
      </Row>
    </Col>
  );
};
export default CategoryData;
